import type { App } from "vue";
import { confirm } from "../../composables/Dialog/confirm";
import { createDialogStack, DIALOG_STACK_KEY, registerStackConfirm, setActiveDialogStack } from "./dialogStack";

export function createDialogPlugin() {
  return {
    install(app: App) {
      const stack = createDialogStack();
      setActiveDialogStack(stack);
      app.provide(DIALOG_STACK_KEY, stack);
      registerStackConfirm(options => confirm(options));
    },
  };
}
